import React from 'react'
import { IconAlertTriangle } from '@tabler/icons-react'
import classNames from 'classnames'

import './ErrorMessage.scss'

/**
 * @import import { ErrorMessage } from '@/components/forms/ErrorMessage'
 * @param {object} props
 * @param {React.ReactNode} props.content The error text, announced by screen readers via role="alert"
 * @param {boolean} [props.warning] Warning styling instead of critical
 * @param {string} [props.className] Additional classes on the alert element
 */
export const ErrorMessage = ({ content, warning, className, ...props }) => {
  return (
    <div role="alert" className={classNames('error-message', className, { warning })} {...props}>
      <IconAlertTriangle />
      <span>{content}</span>
    </div>
  )
}
